import { render, staticRenderFns } from "./AnalysisItem.vue?vue&type=template&id=4ed65b52&scoped=true&"
import script from "./AnalysisItem.vue?vue&type=script&lang=ts&"
export * from "./AnalysisItem.vue?vue&type=script&lang=ts&"
import style0 from "./analysis-item.scss?vue&type=style&index=0&id=4ed65b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed65b52",
  null
  
)

export default component.exports